<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row order-row-list">
    <v-card class="clickable"
            @click="openOrder({order:order,orders:$store.state.orders.data,index:currentIndex})"
    >
      <v-row class="order-row">
        <v-col class=" ml-4">
          <span class="body-2">{{ order.code }}</span>
          <span class="d-inline d-md-none"><br/></span>
          {{ (order.customer ? order.customer.nickname : null) || order.customer_code }}
          <span class="body-2">{{ (order.customer ? order.customer.province : null) }}</span>

          <small v-if="order.customer && !order.customer.gis_is_confirm" class="caption">
            <span class="ml-1 red pa-1" style="color: white;word-break: keep-all"
            >ที่อยู่ยังไม่ยืนยัน</span>
          </small>
<!--          <small v-if="order.do_status" class="caption">-->
<!--            <span class="ml-1  pa-1" :class="{'green':order.do_status=='success','orange':order.do_status=='failed'}" style="color: white;word-break: keep-all">-->
<!--              {{ do_map(order.do_status) }}-->
<!--            </span>-->
<!--          </small>-->


        </v-col>
        <v-col else class="col-2 text-center">
          {{
            order.erp_so_at ? $helper.date_format_short(order.erp_so_at) :
                (order.submitted_at ? $helper.date_format_short(order.submitted_at) : '')
          }}
        </v-col>

        <v-col class="col-2 text-center">
          <v-btn :color="getStatusColor(order.status)" tile>{{ map(order.status) }}</v-btn>

        </v-col>
        <v-col class="col-2 text-right mr-4">
          <span v-if="order.sales && order.sales[0] &&  order.sales[0]['commission_value']>0">
             {{ $helper.number_format(order.sales[0]['commission_value'], 2, 2) }}<br/>
            <span class="caption">/{{ $helper.number_format(order.total_commission_able, 2, 2) }}</span>
          </span>
          <span v-else>
            {{ $helper.number_format(order.total_commission_able, 2, 2) }}
          </span>


        </v-col>
      </v-row>
    </v-card>
  </div>

</template>
<style lang="scss" scoped>
.order-row-list {
  padding: 16px 12px 0;
}

.order-row {

  height: 65px;
  align-items: center;
  line-height: 1.2;
  font-size: 18px;

  .col {
    padding: 4px;
  }
}

@media (min-height: 700px) {
  .order-row {
    font-size: 22px;
  }
}

</style>

<script lang="ts">

import {Component, Prop, Vue} from 'vue-property-decorator'
import {Order, OrderConst} from '../../models/Order'
import Helper from '../../services/Helper.js'

@Component({
  components: {},
})
export default class OrderRow extends Vue {
  @Prop() order: Order
  @Prop() currentIndex: number

  OrderConst = OrderConst

  // number_format(number:number) {
  //   return Helper.number_format(Math.round(number))
  // }

  map(status) {
    return OrderConst.map(status)
  }
  do_map(status) {
    return OrderConst.do_map(status)
  }

  getStatusColor(status) {
    return OrderConst.color(status)
  }
  getDoStatusColor(status) {
    return OrderConst.do_color(status)
  }

  //          {{ order.status>=OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO?$helper.date_format_short(order.erp_so_at):$helper.date_format_short(order.submitted_at)}}

  openOrder(option) {
    this.$root.$emit('openOrder', option)
  }
}

</script>
